import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import './Services.css';

const allServices = [
    {
        id: 2,
        title: "Sviluppo Backend",
        slug: "sviluppo-backend",
        description: "API robuste e scalabili con Node.js, Python e database moderni.",
        icon: "fas fa-gears",
        // price: "A partire da €1200",
        category: "development",
        categoryName: "Sviluppo Software"
    },
    {
        id: 3,
        title: "E-commerce Solutions",
        slug: "e-commerce-solutions",
        description: "Piattaforme e-commerce complete con gestione prodotti e pagamenti.",
        icon: "fas fa-cart-shopping",
        // price: "A partire da €1500",
        category: "development",
        categoryName: "Sviluppo Software"
    },
    {
        id: 4,
        title: "Mobile App Development",
        slug: "mobile-app-development",
        description: "App native e cross-platform per iOS e Android.",
        icon: "fas fa-mobile-screen",
        // price: "A partire da €2000",
        category: "development",
        categoryName: "Sviluppo Software"
    },
    {
        id: 1,
        title: "Sviluppo Web Frontend",
        slug: "sviluppo-web-frontend",
        description: "Interfacce utente moderne e responsive con React, Vue.js e tecnologie all'avanguardia.",
        icon: "fas fa-laptop-code",
        // price: "A partire da €800",
        category: "development",
        categoryName: "Sviluppo Software"
    },
    {
        id: 5,
        title: "UI/UX Design",
        slug: "ui-ux-design",
        description: "Design di interfacce intuitive e user experience ottimizzate.",
        icon: "fas fa-object-group",
        // price: "A partire da €600",
        category: "development",
        categoryName: "Sviluppo Software"
    },
    {
        id: 6,
        title: "Consulenza Tecnica",
        slug: "consulenza-tecnica",
        description: "Analisi e ottimizzazione di progetti esistenti, scelta soluzioni IT e coordinamento con i fornitori.",
        icon: "fas fa-lightbulb",
        // price: "€80/ora",
        category: "consulting",
        categoryName: "Consulenza"
    },
    {
        id: 7,
        title: "Server Linux",
        slug: "server-linux",
        description: "Amministrazione specializzata di server Linux con monitoraggio 24/7.",
        icon: "fab fa-linux",
        // price: "A partire da €120/mese",
        category: "infrastructure",
        categoryName: "Infrastruttura"
    },
    {
        id: 8,
        title: "Server Windows",
        slug: "server-windows",
        description: "Gestione server Windows Server, Active Directory e Exchange.",
        icon: "fab fa-windows",
        // price: "A partire da €180/mese",
        category: "infrastructure",
        categoryName: "Infrastruttura"
    },
    {
        id: 9,
        title: "Centralini VoIP Asterisk",
        slug: "voip-asterisk",
        description: "Installazione, configurazione e assistenza su centralini Asterisk.",
        icon: "fas fa-phone-volume",
        // price: "€50/ora",
        category: "voip",
        categoryName: "VoIP & Telecomunicazioni"
    },
    {
        id: 10,
        title: "Docker",
        slug: "docker",
        description: "Containerizzazione applicazioni, orchestrazione e deployment con Docker.",
        icon: "fab fa-docker",
        // price: "A partire da €200/mese",
        category: "infrastructure",
        categoryName: "Infrastruttura"
    },
    {
        id: 11,
        title: "Kubernetes",
        slug: "kubernetes",
        description: "Orchestrazione container, scaling automatico e gestione cluster K8s.",
        icon: "fas fa-dharmachakra",
        // price: "A partire da €350/mese",
        category: "infrastructure",
        categoryName: "Infrastruttura"
    },
    {
        id: 12,
        title: "Database MySQL",
        slug: "database-mysql",
        description: "Amministrazione, ottimizzazione e clustering database MySQL/MariaDB.",
        icon: "fas fa-database",
        // price: "A partire da €150/mese",
        category: "infrastructure",
        categoryName: "Infrastruttura"
    },
    {
        id: 13,
        title: "Database PostgreSQL",
        slug: "database-postgresql",
        description: "Gestione avanzata PostgreSQL, backup, replicazione e performance tuning.",
        icon: "fas fa-server",
        // price: "A partire da €180/mese",
        category: "infrastructure",
        categoryName: "Infrastruttura"
    },
    {
        id: 14,
        title: "Odoo ERP",
        slug: "odoo",
        description: "Implementazione e personalizzazione del sistema ERP Odoo per la gestione aziendale.",
        icon: "fas fa-cubes",
        // price: "A partire da €2500",
        category: "development",
        categoryName: "Sviluppo Software"
    },
    {
        id: 15,
        title: "Cloud Solutions",
        slug: "cloud-solutions",
        description: "Migrazione e gestione cloud su AWS, Azure e Google Cloud Platform.",
        icon: "fas fa-cloud",
        // price: "A partire da €300/mese",
        category: "infrastructure",
        categoryName: "Infrastruttura"
    },
    {
        id: 16,
        title: "Proxmox VE",
        slug: "proxmox",
        description: "Virtualizzazione open source, Proxmox Backup Server e migrazione da VMware.",
        icon: "fas fa-layer-group",
        category: "infrastructure",
        categoryName: "Infrastruttura"
    },
    {
        id: 17,
        title: "Amministrazione Server",
        slug: "server-administration",
        description: "Gestione server Linux e Windows, monitoraggio 24/7, backup e supporto dedicato.",
        icon: "fas fa-desktop",
        category: "infrastructure",
        categoryName: "Infrastruttura"
    },
    {
        id: 18,
        title: "Digital Transformation",
        slug: "digital-transformation",
        description: "Digitalizzazione dei processi aziendali: automazione, cloud migration e data analytics.",
        icon: "fas fa-arrows-rotate",
        category: "consulting",
        categoryName: "Consulenza",
        link: "/digital-transformation"
    }
];

const categories = [
    { key: 'all', name: 'Tutti i Servizi' },
    { key: 'consulting', name: 'Consulenza' },
    { key: 'development', name: 'Sviluppo Software' },
    { key: 'infrastructure', name: 'Infrastruttura' },
    { key: 'voip', name: 'VoIP & Telecomunicazioni' }
];

function Services() {
    const [activeCategory, setActiveCategory] = useState('all');
    const location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const category = searchParams.get('category');
        if (category && categories.some(cat => cat.key === category)) {
            setActiveCategory(category);
        }
    }, [location.search]);

    const filteredServices = activeCategory === 'all'
        ? allServices
        : allServices.filter(service => service.category === activeCategory);

    return (
        <div className="services-page">
            {/* Hero Section */}
            <section className="services-hero">
                <Container>
                    <Row className="align-items-center min-vh-50">
                        <Col lg={8} className="mx-auto text-center">
                            <h1 className="services-hero-title">
                                I Nostri <span className="gradient-text-light">Servizi</span>
                            </h1>
                            <p className="services-hero-description">
                                Dalla creazione di software su misura all'assistenza tecnica specializzata,
                                offriamo soluzioni complete per far crescere il tuo business.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Services Section */}
            <section className="services-content section-padding">
                <Container>
                    {/* Category Filter */}
                    <Row>
                        <Col lg={10} className="mx-auto">
                            <Nav variant="pills" className="services-nav justify-content-center mb-5">
                                {categories.map(category => (
                                    <Nav.Item key={category.key}>
                                        <Nav.Link
                                            active={activeCategory === category.key}
                                            onClick={() => setActiveCategory(category.key)}
                                            className="category-filter"
                                        >
                                            {category.name}
                                        </Nav.Link>
                                    </Nav.Item>
                                ))}
                            </Nav>
                        </Col>
                    </Row>

                    {/* Services Grid */}
                    <Row>
                        {filteredServices.map((service, index) => (
                            <Col lg={4} md={6} className="mb-4" key={service.id}>
                                <Card className={`service-page-card h-100 fade-in-up`} style={{animationDelay: `${index * 0.1}s`}}>
                                    <Card.Body className="text-center">
                                        <div className="service-icon-large"><i className={service.icon}></i></div>
                                        <Card.Title className="service-page-title">{service.title}</Card.Title>
                                        <div className="service-category-badge">{service.categoryName}</div>
                                        <Card.Text className="service-page-description">
                                            {service.description}
                                        </Card.Text>
                                        {/* <div className="service-page-price">{service.price}</div> */}
                                        <Link
                                            to={service.link || `/services/${service.category}/${service.slug}`}
                                            className="btn-gradient mt-3"
                                        >
                                            <span>Dettagli Servizio</span>
                                        </Link>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
        </div>
    );
}

export default Services;